import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LockIcon from 'Components/icons/LockIcon';
import OutsideClickHandler from 'Components/OutsideClickHandler';

import './PopupMenu.scss';

class PopupMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };

    this.attachBindings();
  }

  attachBindings() {
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
  }

  showTooltip() {
    this.setState({ isHovered: !this.state.isHovered });
  }

  hideTooltip() {
    this.setState({ isHovered: false });
  }

  get lockIcon() {
    return (
      <LockIcon
        onMouseOver={this.showTooltip}
      />
    );
  }

  onClickHandeler = (action) => {
    this.hideTooltip();
    this.props.goToLink(action);
  }

  get popupContent() {
    if (Array.isArray(this.props.popupContent)) {
      return this.props.popupContent.map((content) => {
        return <li onClick={() => this.onClickHandeler(content)} key={content.id}>{content.name.replace(/_/g, ' ')}</li>;
      });
    }

    return null;
  }

  render() {
    const popupClasses = classnames((this.props.parentComponentName == "CreatCustomQueLanding" ? 'popup-menu-white' : 'popup-menu'), `${this.props.poupUpBottom}`, {
      lock: this.props.lock,
      bottom: this.props.position === 'bottom',
      top: this.props.position === 'top',
      left: this.props.position === 'left',
      right: this.props.position === 'right',
    });

    if (this.props.parentComponentName == "CreatCustomQueLanding") {
      return (
        <OutsideClickHandler onClickOutside={this.hideTooltip}>
          <div className="popup-menu-white__wrapper">
            {this.props.lock && this.lockIcon}
            {this.state.isHovered &&
              <div className={popupClasses} >
                <ul className="content">
                  {this.popupContent}
                </ul>
              </div>}
            <span
              className="trailing-text-white"
              onClick={this.showTooltip}
            >{this.props.children}</span>
          </div>
        </OutsideClickHandler>
      );
    } else {
      return (
        <div className="popup-menu__wrapper" onMouseOver={this.showTooltip}>
          {this.props.lock && this.lockIcon}
          {this.state.isHovered &&
            <div
              className={popupClasses}
              onMouseOver={this.showTooltip}
              onMouseLeave={this.hideTooltip}
            >
              <div className="popup-menu__header">
                {this.props.popupTitle && <h1 className="headline">{this.props.icon && this.props.icon} {this.props.popupTitle}</h1>}
                {this.props.dataAccessProhibited && <span
                  role="button"
                  tabIndex={0}
                  className="link"
                  onClick={this.props.goToLink}
                >
                  {this.props.editText}
                </span>}
              </div>
              <ul className="content">
                {this.popupContent}
              </ul>
            </div>}
          <span
            className="trailing-text"
            onMouseOver={this.showTooltip}
          >{this.props.trailingText}</span>
        </div>
      );
    }
  }
}

PopupMenu.propTypes = {
  lock: PropTypes.bool,
  icon: PropTypes.element,
  position: PropTypes.string.isRequired,
  popupTitle: PropTypes.string,
  popupContent: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.oneOf([null]),
  ]).isRequired,
  trailingText: PropTypes.string.isRequired,
  goToLink: PropTypes.func,
  dataAccessProhibited: PropTypes.bool,
  editText: PropTypes.string.isRequired,
  parentComponentName: PropTypes.string,
  poupUpBottom: PropTypes.string,
};

PopupMenu.defaultProps = {
  lock: false,
  goToLink: () => { },
  icon: null,
  popupTitle: '',
  history: {},
  dataAccessProhibited: false,
  parentComponentName: "",
  poupUpBottom: "",
};

export default PopupMenu;
